import { StoreAction } from "../../@core/constants";

const initialState = {
  websetting: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case StoreAction.GET_WEB_SETTING_DATA:
      return {
        ...state,
        websetting: action.payload,
      };
    default:
      return state;
  }
}
